export default __webpack_public_path__ + "static/media/manila-2-map.c6df7d0d.jpg";